module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Marker":"Pin","Play animation":"Animation abspielen"}}')
  delete Component.options._Ctor
}
